/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
// libraries
import React from 'react';
import { object } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import mbpLogger from 'mbp-logger';
import { useUIDSeed } from 'react-uid';
// components
import LeftRail from '../../GraphqlCategoryPage/Partials/RailMenuTabletContainer/RailCategoryRelatedBox';
import SideRailBanner from '../../GraphqlCategoryPage/Partials/GraphqlLeftMenuContainer/Partials/GraphqlSideRailBanner';
import GraphqlCategoryRelatedBox from  '../../GraphqlCategoryPage/Partials/GraphqlLeftMenuContainer/Partials/GraphqlCategoryRelatedBox';
import isEmptyReference from '../../../../helpers/contentstack/isEmptyReference';

const styles = (theme) => ({
    leftMenuComponent: {
        display: 'none',
        [theme.breakpoints.up(769)]: {
            display: 'block',
            width: '100%',
            marginBottom: '15px',
        },
    },
});

const MasterTemplateLeftRail = ({
    block, classes,
}) => {
    if (!block) {
        mbpLogger.logWarning({
            message: 'No block types have been passed into MasterTemplateLeftRail.js',
        });
        return null;
    }
    const blockKey = Object.keys(block)[0];
    const blockObj = block[blockKey];
    const seed = useUIDSeed();
    if (isEmptyReference(blockObj, blockKey, 'MasterMasterTemplateLeftRail.js')) return null;

    const subNavCategoryRelatedBoxBlock = (
        <Grid
            className={classes.leftMenuComponent}
            key={seed(blockObj)}
        >
            <GraphqlCategoryRelatedBox relatedData={blockObj} />
        </Grid>
    );
    switch (blockKey) {
        case 'left_rails':
            return <LeftRail data={blockObj} blockName={blockKey} />;

        case 'related_articles':
            return (
                subNavCategoryRelatedBoxBlock
            );

        case 'related_searches':
            return (
                subNavCategoryRelatedBoxBlock
            );

        case 'side_rail_banner':
            return <SideRailBanner bannerData={blockObj} />;

        default:
            mbpLogger.logWarning({
                message: `Unknown HomePage block type "${blockKey}" in MasterTemplateLeftRail.js`,
            });
            return null;
    }
};

MasterTemplateLeftRail.propTypes = {
    classes: object.isRequired,
    block: object.isRequired,
};

export default withStyles(styles)(MasterTemplateLeftRail);
